import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ClaimService {

  private _step = 0;
  public _isFlyout = false;
  constructor() { }

  get claimStep() {
    return this._step;
  }

  set claimStep(value: number) {
    if (this._step + 1 === value) {
      this._step = value;
    }
  }

  resetStep() {
    this._step = 0;
  }

}
